<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px" height="1300px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark class="mx-auto mt-3 mt-sm-0" v-on="on" text>
          <v-icon class="mr-2" small>fal fa-plus</v-icon>
          New unit
        </v-btn>
      </template>
      <v-stepper v-model="step" height="40vh">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            Unit Type
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 2" step="2">
            Unit Content
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="step > 3" step="3">
            Unit Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4"> Assign Unit </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1" class="text-center">
            <v-container class="text-center">
              <v-btn
                text
                class="btn-unit-type"
                @click="selectUnitType('video')"
              >
                <i class="fa fa-upload fa-sm mr-2" /> Upload Video
              </v-btn>
              <v-btn text class="btn-unit-type" @click="selectUnitType('text')">
                <i class="fa fa-newspaper fa-sm mr-2" /> Text Content
              </v-btn>
            </v-container>
            <v-btn text color="blue-grey darken-1" @click="close">
              Close
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-container v-if="unitType == 'video'">
              <template v-if="!youtube_url">
                <dashboard
                  :uppy="uppy"
                  :props="{
                    proudlyDisplayPoweredByUppy: false,
                    metaFields: [
                      { id: 'name', name: 'Name', placeholder: 'File name' },
                    ],
                    showProgressDetails: true,
                    hidePauseResumeButton: true,
                    hideCancelButton: false,
                    hideProgressAfterFinish: true,
                    hideUploadButton: true,
                    doneButtonHandler: null,
                    height: 300,
                    allowedFileTypes: ['video/*'],
                  }"
                />
                <progress-bar
                  :uppy="uppy"
                  :props="{
                    hideAfterFinish: false,
                  }"
                />
                <v-divider />
              </template>
              <v-text-field
                @input="fetchVideoId"
                type="url"
                :disabled="loading"
                v-model="youtube_url"
                label="Youtube or Vimeo URL"
                name="youtube_url"
                v-if="!files"
              ></v-text-field>
            </v-container>
            <v-container v-else>
              <v-file-input
                v-model="textFile.file"
                label="Upload PDF File"
                name="thumbnail"
                accept="application/pdf,"
              ></v-file-input>
              <div class="form-group">
                <jodit-vue v-model="unit.content"></jodit-vue>
              </div>
            </v-container>
            <v-btn
              v-if="unitType == 'video'"
              color="primary"
              :loading="loading"
              :disabled="loading || !files || youtube_id == ''"
              @click="stepContinue"
            >
              Continue
            </v-btn>
            <v-btn
              v-else
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="saveContent"
            >
              Save & Continue
            </v-btn>

            <v-btn
              text
              color="blue-grey darken-1"
              :disabled="loading"
              @click="step = 1"
            >
              Back
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-container>
              <v-row>
                <v-col
                  :cols="isVideoUploaded ? '6' : '12'"
                  sm="12"
                  :md="isVideoUploaded ? '6' : '12'"
                >
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="unit.name"
                      label="Unit Name"
                      name="name"
                      :disabled="loading"
                      :loading="loading"
                      v-validate="'required'"
                    ></v-text-field>
                    <span
                      class="kt-font-danger validate-error"
                      v-show="errors.has('name')"
                      >{{ errors.first('name') }}</span
                    >
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="unit.thumbnail"
                      label="Thumbnail"
                      name="thumbnail"
                      accept="image/*"
                      :disabled="loading"
                      :loading="loading"
                      @click="toggleUploadDialog"
                    ></v-text-field>
                    <span
                      class="kt-font-danger validate-error"
                      v-show="errors.has('thumbnail')"
                      >{{ errors.first('thumbnail') }}</span
                    >
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <label>Quiz</label>
                    <multiselect
                      v-model="unit.quiz_id"
                      :options="quizzes"
                      label="title"
                      track-by="id"
                      searchable
                      @search-change="searchQuizzes"
                      placeholder="Select a Quiz"
                      :loading="quizPagination.loading || loading"
                      :disabled="quizPagination.loading || loading"
                    >
                      <template slot="singleLabel" slot-scope="{ option }">
                        <strong>{{ option.title }}</strong>
                      </template>
                      <span slot="noOptions">Search Quiz...</span>
                      <span slot="noResult">
                        Oops! No elements found. Consider changing the search
                        query.
                      </span>
                      <template slot="afterList">
                        <div
                          v-observe-visibility="nextQuizPage"
                          v-if="
                            quizPagination.current !== quizPagination.last_page
                          "
                        />
                      </template>
                    </multiselect>
                  </v-col>
                </v-col>
                <v-col v-if="isVideoUploaded" cols="6" sm="12" md="6">
                  <v-card class="mx-auto">
                    <iframe
                      v-if="!isUploading"
                      :src="video.url"
                      frameborder="0"
                      allowfullscreen=""
                      style="width: 100%; height: 100%; background-color: black"
                    />
                    <v-img
                      v-else
                      src="https://songdewnetwork.com/sgmedia/assets/images/default-video-image.png"
                    />

                    <v-card-title> Current Video </v-card-title>

                    <v-card-subtitle>
                      <v-text-field
                        v-model="unit.video_duration"
                        :disabled="loading"
                        :loading="loading"
                        label="Video Duration"
                        name="video_duration"
                      ></v-text-field>
                    </v-card-subtitle>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-col cols="12" sm="12" md="12">
                    <label>Unit Description</label>
                    <jodit-vue
                      :disabled="loading"
                      :loading="loading"
                      name="description"
                      v-model="unit.description"
                      :buttons="[]"
                      :config="{
                        uploader: { url: 'none' },
                      }"
                    >
                    </jodit-vue>
                    <span
                      class="kt-font-danger validate-error"
                      v-show="errors.has('description')"
                      >{{ errors.first('description') }}</span
                    >
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="unit.call_guide_link"
                      label="Call Guide"
                      name="call_guide_link"
                      :disabled="loading"
                      :loading="loading"
                      @click="toggleCallGuideDialog"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-combobox
                      v-model="unit.tags"
                      label="Tags"
                      name="tags"
                      :items="tags"
                      :item-text="(item) => item.name"
                      :item-value="(item) => item.id"
                      multiple
                      chips
                      prepend-icon="fal fa-tags"
                      :disabled="loading"
                      :loading="loading"
                      :menu-props="{ closeOnClick: true }"
                    ></v-combobox>
                    <span
                      class="kt-font-danger validate-error"
                      v-show="errors.has('tags')"
                      >{{ errors.first('tags') }}</span
                    >
                  </v-col>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-switch
                    v-model="unit.is_draft"
                    :label="`Draft`"
                    :disabled="loading"
                    :loading="loading"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-container>

            <v-btn
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="saveDetails"
            >
              Save & Continue
            </v-btn>

            <v-btn
              text
              color="blue-grey darken-1"
              :disabled="loading"
              @click="close"
            >
              Cancel
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="course_id"
                    name="course_id"
                    label="Curriculum"
                    :items="curriculums"
                    :disabled="loading"
                    :loading="loading"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.id"
                    @change="fetchCourses"
                    :menu-props="{ closeOnClick: true }"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                    <template v-slot:item="data">
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ data.item.name }}
                          <span
                            :class="
                              data.item.is_draft
                                ? 'text-small'
                                : 'text-success text-small'
                            "
                            >({{
                              data.item.is_draft ? 'Draft' : 'Published'
                            }})</span
                          >
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-html="data.item.company_author.name"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('course_id')"
                    >{{ errors.first('course_id') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="category_id"
                    name="category_id"
                    :disabled="course_id == null || loading"
                    :loading="loading"
                    label="Course (Select A Curriculum To be able to select Course)"
                    :items="categories"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.id"
                    @change="fetchModules"
                    :menu-props="{ closeOnClick: true }"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                  </v-autocomplete>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('category_id')"
                    >{{ errors.first('category_id') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="unit.module_id"
                    :disabled="category_id == null || loading"
                    :loading="loading"
                    name="module_id"
                    label="Module (Select A Course To be able to select Module)"
                    @change="fetchSeries"
                    :items="modules"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.id"
                    :menu-props="{ closeOnClick: true }"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                  </v-autocomplete>
                  <span
                    class="kt-font-danger validate-error"
                    v-show="errors.has('module_id')"
                    >{{ errors.first('module_id') }}</span
                  >
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-autocomplete
                    v-model="unit.series_id"
                    :disabled="unit.module_id == null || loading"
                    name="series_id"
                    :label="`Series (Select A Module To be able to select Series)`"
                    :items="series"
                    :item-text="(item) => item.name"
                    :item-value="(item) => item.id"
                    :menu-props="{ closeOnClick: true }"
                    :loading="loading"
                  >
                    <template v-slot:selection="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                    <template v-slot:item="data">
                      {{ data.item.name }} &nbsp;
                      <span
                        :class="
                          data.item.is_draft
                            ? 'text-small'
                            : 'text-success text-small'
                        "
                        >({{
                          data.item.is_draft ? 'Draft' : 'Published'
                        }})</span
                      >
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>

            <v-btn
              color="primary"
              :loading="loading"
              :disabled="loading"
              @click="assignUnitToModule"
            >
              Save
            </v-btn>

            <v-btn
              text
              color="blue-grey darken-1"
              :disabled="loading"
              @click="previewUnit(unit.id)"
            >
              Preview
            </v-btn>
            <v-btn
              text
              color="blue-grey darken-1"
              :disabled="loading"
              @click="close"
            >
              Cancel
            </v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
    <upload-file-dialog
      :type="['image']"
      :show-upload-dialog="showUploadDialog"
      :upload-dialog="toggleUploadDialog"
      :close-dialog="closeUploadDialog"
      v-on:showImage="getThumbnail"
    />
    <upload-file-dialog
      :type="'all'"
      :show-upload-dialog="showCallGuideDialog"
      :upload-dialog="toggleCallGuideDialog"
      :close-dialog="closeUploadDialog"
      v-on:showImage="getCallGuide"
    />
  </v-row>
</template>

<script>
import Uppy from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { Dashboard, DashboardModal, DragDrop, ProgressBar } from '@uppy/vue';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import Multiselect from 'vue-multiselect';
import UploadFileDialog from '@/components/dialogs/UploadFileDialog';
import {
  forEach as _forEach,
  debounce as _debounce,
  sortBy as _sortBy,
  isEmpty as _isEmpty,
  findIndex as _findIndex,
} from 'lodash-es';
export default {
  name: 'addUnit',
  components: {
    Dashboard,
    DashboardModal,
    DragDrop,
    ProgressBar,
    Multiselect,
    UploadFileDialog,
  },
  mounted() {
    console.log(process.env.BASE_URL);
    this.xhrUploadHost = window.location.origin;
  },
  data: () => ({
    thumbnailVimeo: null,
    dialog: false,
    step: 1,
    files: null,
    unitType: '',
    draft: {},
    unit: {
      quiz_id: '',
      id: '',
      name: '',
      thumbnail: [],
      description: '',
      video_duration: '00:00:00',
      call_guide_link: '',
      content: '',
      uploadedImage: [],
      tags: [],
      uploadedImageLabel: '',
      module_id: null,
      series_id: null,
    },
    quizzes: [],
    quizPagination: {
      current: 1,
      last_page: 1,
      loading: false,
    },
    textFile: {
      file: null,
      isStream: true,
      isDownload: false,
    },
    course_id: null,
    category_id: null,
    categories: [],
    modules: [],
    curriculums: [],
    series: [],
    tags: [],
    loading: false,

    //  VIDEOS
    isVideoUploaded: false,
    youtube_url: null,
    youtube_id: null,
    urlSource: '',
    debounce: null,
    video: {},
    isUploading: false,
    xhrUploadHost: '',

    //FILEUPLOAD
    showUploadDialog: false,
    showCallGuideDialog: false,
  }),

  created() {
    this.fetchQuizzes();
    this.$store.dispatch('units/fetchTags').then(({ data }) => {
      this.tags = data;
    });
    this.fetchCurriculums();
  },

  computed: {
    uppy() {
      let vm = this;
      return new Uppy({
        id: 'uppyMain',
        debug: true,
        allowMultipleUploads: false,
        autoProceed: false,
        restrictions: {
          allowedFileTypes: ['video/*'],
          maxFileSize: 1000 * 1024 * 1024,
          maxNumberOfFiles: 1,
        },
      })
        .on('file-added', (file) => {
          this.isLoading = true;
          this.addFile(file.data);
        })
        .on('file-removed', (file) => {
          this.isLoading = true;
          this.removeFile();
        })
        .on('cancel-all', () => {
          this.isLoading = true;
          this.removeFile();
        });
    },
    curriculums() {
      return this.$store.state.curriculums.curriculums;
    },
    curriculumsReady() {
      return this.$store.state.curriculums.isCurriculumsReady;
    },
  },

  beforeDestroy() {
    this.uppy.close();
  },

  methods: {
    fetchCurriculums() {
      if (!this.curriculumsReady) {
        this.loading = true;
        this.setCurriculums();
        this.loading = false;
      }
    },
    addFile(file) {
      this.files = file;
      this.isLoading = false;
    },
    removeFile() {
      this.files = null;
      this.isLoading = false;
    },

    searchQuizzes: _debounce(function (query) {
      this.search = query;
      this.fetchQuizzes();
    }, 500),

    selectUnitType(type) {
      this.unitType = type;
      this.step = 2;
    },

    fetchCourses() {
      this.loading = true;
      this.axios
        .get('/client/lms/fetchCurriculumCourses', {
          params: { curriculum_id: this.course_id },
        })
        .then(({ data }) => {
          this.categories = data;
        })
        .catch((error) => {
          console.log('something went wrong with fetching courses');
        })
        .finally((data) => {
          this.loading = false;
        });
    },

    fetchModules() {
      this.loading = true;
      this.axios
        .get('/client/lms/fetchCourseModules', {
          params: {
            course_id: this.category_id,
          },
        })
        .then(({ data }) => {
          this.modules = data;
          this.loading = false;
        })
        .catch((error) => {
          console.log('something went wrong with fetching modules');
        })
        .finally((data) => {
          this.loading = false;
        });
    },

    fetchSeries() {
      this.loading = true;
      this.axios
        .get('/client/lms/fetchSeries', {
          params: { module_id: this.unit.module_id },
        })
        .then(({ data }) => {
          this.series = data;
        })
        .catch((error) => {
          console.log('something went wrong with fetching series');
        })
        .finally((data) => {
          this.loading = false;
        });
    },

    setForm() {
      const form = new FormData();
      form.append('unit_id', this.draft.id);
      form.append('name', this.unit.name);
      form.append('description', this.unit.description);
      form.append('call_guide_link', this.unit.call_guide_link);
      form.append('video_duration', this.unit.video_duration);
      form.append('is_draft', this.unit.is_draft);
      if (this.unit.quiz_id) {
        form.append('quiz_id', this.unit.quiz_id.id);
      }
      _forEach(this.unit.tags, (tag) => {
        typeof tag === 'object'
          ? form.append('tags[]', tag.id)
          : form.append('tags[]', tag);
      });
      form.append('thumbnail', this.unit.thumbnail);

      return form;
    },

    stepContinue() {
      const request = {
        type: this.unitType,
        files: this.files,
        url: this.youtube_id,
        urlSource: this.urlSource,
      };
      const form = new FormData();
      if (this.youtube_url) {
        form.append('url', this.youtube_id);
        form.append('urlSource', this.urlSource);
      } else {
        form.append('files', this.files);
      }
      form.append('type', this.unitType);
      this.loading = true;
      this.$http
        .post('lms-manager/upload/units/video', form)
        .then((response) => {
          this.draft = response.data.unit;
          this.unit.video_duration = this.draft.video_duration;
          if (response.data.video) {
            this.video = response.data.video;
            this.isVideoUploaded = true;
          }
          this.step = 3;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally((response) => {
          this.$notify('success', 'Draft unit saved!');
          this.$emit('fetch-units');
          this.loading = false;
        });
    },

    saveContent() {
      const form = new FormData();
      form.append('content', this.unit.content);
      form.append('file', this.textFile.file);
      form.append('isStream', this.textFile.isStream);
      form.append('isDownload', this.textFile.isDownload);
      this.loading = true;

      this.axios
        .post('lms-manager/units/save/content', form)
        .then((resposne) => {
          this.draft = resposne.data.unit;
          this.step = 3;
        })
        .catch((response) => {
          this.interactWithErrorBag(response, this.errors);
        })
        .finally((response) => {
          this.$notify('success', 'Draft unit saved!');
          this.$emit('fetch-units');
          this.loading = false;
        });
    },

    saveDetails() {
      this.$validator.validate('*').then((result) => {
        console.log(result);
        if (result) {
          this.loading = true;
          this.axios
            .post('lms-manager/units/save/details', this.setForm())
            .then((response) => {
              this.unit = response.data.unit;
              this.draft = response.data.unit;
              this.step = 4;
              this.$emit('fetch-units');
            })
            .catch((response) => {
              this.interactWithErrorBag(response, this.errors);
            })
            .finally((response) => {
              this.$notify('success', 'Unit Details Saved!');
              this.loading = false;
            });
        }
      });
    },

    assignUnitToModule() {
      this.loading = true;

      this.axios
        .post('lms-manager/units/save/assign', {
          unit_id: this.unit.id,
          module_id: this.unit.module_id,
          series_id: this.unit.series_id,
        })
        .then((response) => {
          this.unit = response.data;
        })
        .catch((response) => {
          console.log(response);
        })
        .finally((response) => {
          this.$notify('success', 'Unit Saved!');
          this.loading = false;
          this.$emit('fetch-units');
          this.close();
        });
    },

    fetchQuizzes() {
      this.quizPagination.loading = true;
      const page = _isEmpty(this.search) ? this.quizPagination.current : 1;
      this.axios
        .get('lms-manager/builder/quizzes', {
          params: {
            page,
            type: 'Active',
            itemsPerPage: 5,
            search: this.search,
          },
        })
        .then(({ data }) => {
          _forEach(data.data, (quiz) => {
            const index = _findIndex(this.quizzes, { id: quiz.id });
            if (index === -1) {
              this.quizzes.push(quiz);
            }
          });
          if (_isEmpty(this.search)) {
            this.quizPagination.last_page = data.last_page;
          }
          this.quizPagination.loading = false;
        })
        .catch((error) => {
          this.quizPagination.loading = false;
        });
    },

    previewUnit(id) {
      let routeData = this.$router.resolve({
        name: 'PreviewUnitPage',
        params: {
          id,
        },
      });
      console.log(routeData);
      window.open(routeData.href, '_blank');
    },

    close() {
      this.unit = {
        quiz_id: '',
        id: '',
        name: '',
        thumbnail: [],
        description: '',
        video_duration: '00:00:00',
        call_guide_link: '',
        content: '',
        uploadedImage: [],
        tags: [],
        uploadedImageLabel: '',
        module_id: null,
        series_id: null,
      };
      this.textFile = {
        file: null,
        isStream: false,
        isDownload: false,
      };
      this.isVideoUploaded = false;
      this.draft = {};
      this.video = {};
      this.files = [];
      this.youtube_url = null;
      this.youtube_id = null;
      this.urlSource = '';
      this.dialog = false;
      this.step = 1;
      this.uppy.close();
    },

    youtubeParser() {
      let regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
      let match = this.youtube_url.match(regExp);
      let youtubeId = match && match[7].length == 11 ? match[7] : false;
      console.log(youtubeId);
      if (youtubeId) {
        this.youtube_id = match && match[7].length == 11 ? match[7] : false;
        this.urlSource = 'youtube';
      } else {
        this.$notify('warning', 'Not a Youtube or Vimeo URL');
        this.youtube_url = null;
        this.youtube_id = null;
      }
    },

    getIdFromVimeoURL(url) {
      const vUrl =
        /(https?:\/\/)?(www\.)?(player\.)?vimeo\.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/.exec(
          url
        );
      return vUrl[vUrl.length - 1];
    },

    fetchVideoId(url) {
      if (this.debounce !== null) clearTimeout(this.debounce);
      let vm = this;
      this.debounce = setTimeout(function () {
        vm.loading = true;
        if (url.includes('vimeo')) {
          vm.youtube_id = vm.getIdFromVimeoURL(url);
          vm.urlSource = 'vimeo';
        } else {
          vm.youtubeParser();
        }
        vm.loading = false;
      }, 500);
    },
    getCookie(cname) {
      let name = cname + '=';
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
    toggleUploadDialog() {
      this.showUploadDialog = true;
    },
    toggleCallGuideDialog() {
      this.showCallGuideDialog = true;
    },
    closeUploadDialog() {
      this.showUploadDialog = false;
      this.showCallGuideDialog = false;
    },
    getThumbnail(item) {
      this.unit.thumbnail = item.value;
      if (item.type == 'upload') {
        this.thumbnailDisplay = URL.createObjectURL(this.unit.thumbnail);
      } else {
        this.thumbnailDisplay = this.unit.thumbnail;
      }
    },
    getCallGuide(item) {
      this.unit.call_guide_link = item.value;
    },
  },
};
</script>

<style scoped>
a.uppy-Dashboard-poweredBy {
  display: none !important;
}
/*.container {*/
/*  min-height: 700px !important;*/
/*}*/
.btn-unit-type {
  margin: 10% 35px 10% 35px;
  border: 0.7px dashed;
  border-color: rgb(249, 180, 24);
}
.primary-webi {
  background-color: rgb(249, 180, 24);
  border-color: rgb(249, 180, 24);
}

.btn-unit-type {
  padding: 55px !important;
}
</style>
<style src="@uppy/core/dist/style.css"></style>
<style src="@uppy/dashboard/dist/style.css"></style>
<style src="@uppy/drag-drop/dist/style.css"></style>
<style src="@uppy/progress-bar/dist/style.css"></style>
